import React from 'react';
import GeneralModal from '../../../../components/GeneralModal/GeneralModal';
import { useDeleteEquipmentMutation } from '../../../../store/builder/inspections.api';
import { toast } from 'react-toastify';
import { useTranslation } from '../../../../hooks/useTranslation';

const ArchiveEquipmentModal = ({ equipment, setIsOpen, getEquipmentsInitial }) => {
    const [archiveEquipment, { isLoading: archiveEquipmentIsLoading }] = useDeleteEquipmentMutation();
    const {t} = useTranslation();
    const handleArchive = () => {
        archiveEquipment(equipment?.id).then((res) => {
            if (res?.data?.message) {
                toast.success(res?.data?.message);
            }
            if (res?.error) {
                toast.error(res?.error?.data?.message);
            }
            setIsOpen(false);
            getEquipmentsInitial();
        });
    }
  return (
    <GeneralModal
      title={t('equipmentTable.modals.archive.title')}
      onClose={() => setIsOpen(false)}
      onSubmit={handleArchive}
      submitTitle={t('equipmentTable.actions.archive')}
      btnType='delete'
      disableSubmit={archiveEquipmentIsLoading}
    >
      <div className='modal__content-body'>
        <p>{t('equipmentTable.messages.archiveEquipment')}</p>
      </div>
    </GeneralModal>
  );
};

export default ArchiveEquipmentModal;   